// src/Footer.js
import React from 'react';
import './style.css'; // opzionale se vuoi uno stile personalizzato

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        © {new Date().getFullYear()} Car Show, Powered by{' '}
        <a
          href="https://ansoweb.com"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          Ansoweb
        </a>. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
